import {useCommonStore} from "@/core/store/common";
import {useDebugStore} from "@/core/store/debug";
import {createRootStore} from "@/core/store/root";
import {StoreConfig} from "@/core/types";
import {useVacancyStore} from "@/modules/company/store/vacancy";
import {useFaqStore} from "@/modules/faq/store/faq";
import {useFeatureStore} from "@/modules/feature/store/featrue";
import {useFortuneStore} from "@/modules/fortune/store/fortune";
import {useMenuStore} from "@/modules/menu/store/menu";
import {useNoticeStore} from "@/modules/notice/store/notice";
import {useOfferStore} from "@/modules/offer/store/offer";
import {usePagesStore} from "@/modules/page/store/pages";
import {usePushStore} from "@/modules/push";
import {useReviewStore} from "@/modules/review/store/review";
import {useCatalogStore} from "@/modules/shop/store/catalog";
import {useCatalogFavStore} from "@/modules/shop/store/catalog-fav";
import {useDeliveryStore} from "@/modules/shop/store/delivery";
import {useLoalityStore} from "@/modules/shop/store/loyalty";
import {useOrderProfileStore} from "@/modules/shop/store/order-profile";
import {useOrdersStore} from "@/modules/shop/store/orders";
import {useProductModificatorStore} from "@/modules/shop/store/product-modificator";
import {useProductModificatorsComputedStore} from "@/modules/shop/store/product-modificators-computed";
import {useShopStore} from "@/modules/shop/store/shop";
import {useVorderStore} from "@/modules/shop/store/vorder";
import {useUserStore} from "@/modules/user/store/user";
import {useCameraStore} from "@/modules/camera/store/camera";
import {useYandexMetrikaStore} from "@/modules/yandex/store/metrika";
import {useUtmStore} from "@/modules/marketing/store/utm";

export function useRootStore() {

    const stores: Record<string, StoreConfig> = {
        common: {
            callback: useCommonStore,
            boot: true,
        },
        debug: {
            callback: useDebugStore,
            boot: true,
        },
        pages: {
            callback: usePagesStore,
            boot: true,
        },
        feature: {
            callback: useFeatureStore,
            boot: true,
        },
        catalog: {
            callback: useCatalogStore,
            boot: true,
        },
        fortune: {
            callback: useFortuneStore,
            boot: true,
        },
        vorder: {
            callback: useVorderStore,
            boot: true,
        },
        vorderModificator: {
            callback: useProductModificatorStore,
            boot: true,
        },
        vorderModificatorComputed: {
            callback: useProductModificatorsComputedStore,
            boot: true,
        },
        shop: {
            callback: useShopStore,
            boot: true,
        },
        offer: {
            callback: useOfferStore,
            boot: true,
        },
        menu: {
            callback: useMenuStore,
            boot: true,
            rootGetters: true,
        },
        notice: {
            callback: useNoticeStore,
            boot: true,
            rootGetters: true,
        },
        user: {
            callback: useUserStore,
            boot: true,
        },
        fav: {
            callback: useCatalogFavStore,
            boot: true,
        },
        faq: {
            callback: useFaqStore,
            boot: true,
        },
        camera: {
            callback: useCameraStore,
            boot: true,
        },
        review: {
            callback: useReviewStore,
            boot: true,
        },
        vacancy: {
            callback: useVacancyStore,
            boot: true,
        },
        order_profile: {
            callback: useOrderProfileStore,
            boot: true,
        },
        delivery: {
            callback: useDeliveryStore,
            boot: true,
        },
        orders: {
            callback: useOrdersStore,
            boot: true,
        },
        loality: {
            callback: useLoalityStore,
            boot: true,
        },
        push: {
            callback: usePushStore,
            boot: false, // Инициализируется вручную при необходимости
        },
        yandex: {
            callback: useYandexMetrikaStore,
            boot: true,
        },
        marketingUtm: {
            callback: useUtmStore,
            boot: true,
        },
    };

    const root = createRootStore(stores)

    return {
        stores,
        ...root
    };
}
